export type IContainerType =
  | "general20"
  | "general40"
  | "general45"
  | "general53"
  | "tank20"
  | "tank40"
  | "tank45"
  | "flat20"
  | "flat40"
  | "openTop20"
  | "openTop40"
  | "platform20"
  | "platform40"
  | "reefer20"
  | "reefer40";

export const allContainerTypes: IContainerType[] = [
  "general20",
  "general40",
  "general45",
  "general53",
  "tank20",
  "tank40",
  "tank45",
  "flat20",
  "flat40",
  "openTop20",
  "openTop40",
  "platform20",
  "platform40",
  "reefer20",
  "reefer40",
];

export function separateTypeAndSize(s: IContainerType): {
  onlyType: "general" | "tank" | "flat" | "openTop" | "platform" | "reefer";
  sizeStr: "20" | "40" | "45" | "53";
} {
  const sizeStr = s.substring(s.length - 2) as "20" | "40" | "45" | "53";
  const onlyType = s.substring(0, s.length - 2) as
    | "general"
    | "tank"
    | "flat"
    | "openTop"
    | "platform"
    | "reefer";
  return {
    onlyType,
    sizeStr,
  };
}

export function filterOnlyUsesSizes(
  usesSizes: string[] | undefined | "",
  listOfContainerTypes: IContainerType[],
): IContainerType[] {
  if (typeof usesSizes === "undefined" || usesSizes === "")
    return listOfContainerTypes;

  if (Array.isArray(usesSizes) && usesSizes.length === 0)
    return listOfContainerTypes;

  return listOfContainerTypes.filter((s) =>
    usesSizes.includes(separateTypeAndSize(s).sizeStr),
  );
}
